<template>
  <div :class="{'driver-location-not-connected': isAbsolute, 'driver-location-not-connected-style': true}">
    <svg-icon style="color: red; width: 30px; heigth: 30px" name="driver-hover-card" ></svg-icon>
    <span> Please remind the driver to turn on Share Location in the Trucker Path app. Afterwards their real-time location will be synchronized</span>
    <span @click="close" >
      <svg-icon style="height: 16px;width: 16px;" class="close" name="icon-16-close" ></svg-icon>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isAbsolute: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('closeDriverPanel')
    }
  }
}
</script>

<style scoped>
.driver-location-not-connected {
  position: absolute;
  z-index: 200;
  top: 0;
}
.driver-location-not-connected-style {
  width: 100%;
  height: 56px;
  display: flex;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  background: #FFF5EB;
}
span {
  font-family: OpenSans;
  font-size: 12px;
  padding: 0 3px 0 8px;
}
.close {
  cursor: pointer;
}
</style>